import LMSDispatcher from "../LMSDispatcher";
import { IApi, Api } from "../../utilities/Api";
import { ApiRequest } from "../../utilities/ApiRequest";
import * as ACTIONCONTANTS from "./ActionConstants";
import i18next from "i18next";


class LicenseActions {
    private readonly api: IApi;

    constructor() {
        this.api = new Api(ACTIONCONTANTS.LICENSE_ENDPOINT);
    }

    async uploadLicenseFile(file:any) {
        try {
          const request = new ApiRequest("/License/upload", "", file, "License File not found.");
          const result = await this.api.licensePost(request);
          LMSDispatcher.dispatch({
            type: ACTIONCONTANTS.LICENSE_UPLOAD_FILE,
            payload: {
              licenseData: result,
            },
          });
        } catch (error) {
          throw error;
        }
      }

      async getLicenseDetails() {
        try {
          const request = new ApiRequest("/License/getLicenseDetails", "", null, "License not found.");
          const result = await this.api.licenseGet(request);
          LMSDispatcher.dispatch({
            type: ACTIONCONTANTS.LICENSE_DETAILS,
            payload: {
              licenseData: result,
            },
          });
        } catch (error) {
          throw error;
        }
      }
}
const licenseActions = new LicenseActions();
export default licenseActions;
